import { render, staticRenderFns } from "./RollingStockType.vue?vue&type=template&id=894100d6"
import script from "./RollingStockType.vue?vue&type=script&lang=js"
export * from "./RollingStockType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports